import { ColumnDef } from "@tanstack/react-table";
import { CommercialActiveUserProps, CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";

export const TableColumns: ColumnDef<CommercialActiveUserProps>[] = [
    {
    accessorFn: (row) => row.user?.user_profile?.name,
    id: "name",
    header: "Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.email,
    id: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.mobile_no,
    id: "mobile_no",
    header: "Mobile No.",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.year,
    id: "year",
    header: "Year",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.month,
    id: "month",
    header: "Month",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.video_watched,
    id: "video_watch_count",
    header: "Video Watch Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.CheyChey,
    id: " CheyChey",
    header: "CheyChey Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.others,
    id: "others",
    header: "Other Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.total_count,
    id: "total_count",
    header: "Total Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
];
